import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { LegalNoticeText } from "src/components/LegalNotice";

export const PromotionPreamble = () => {
  return (
    <Stack gap={2}>
      <Typography variant="h4" color="primary" textAlign="center">
        OFFICIAL RULES
      </Typography>
      <Box
        display="flex"
        flexDirection="column"
        gap={1}
        textAlign="center"
        sx={{ "& p": { lineHeight: 1.4 } }}
      >
        <LegalNoticeText>
          NO PURCHASE NECESSARY. A PURCHASE OR PAYMENT OF ANY KIND WILL NOT
          INCREASE YOUR CHANCES OF WINNING.
        </LegalNoticeText>
        <LegalNoticeText>
          PARTICIPATION IS LIMITED TO LEGAL RESIDENTS OF THE 50 UNITED STATES
          &amp; THE DISTRICT OF COLUMBIA.
        </LegalNoticeText>
        <LegalNoticeText>VOID WHERE PROHIBITED.</LegalNoticeText>
        <LegalNoticeText>
          THIS PROMOTION SHALL BE CONSTRUED ACCORDING TO AND GOVERNED
          EXCLUSIVELY BY U.S. LAW.
        </LegalNoticeText>
      </Box>
    </Stack>
  );
};
